import React, {useEffect, useRef} from 'react';

export default function IntroPopover({isOpen, onClose, ariaLabel, children, popoverSeen,popoverRight }) {
    const popoverRef = useRef(null);

    // Close on ESC
    useEffect(() => {
        if (!isOpen) return;
        const onKeyDown = (e) => {
            if (e.key === 'Escape') onClose?.();
        };
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [isOpen, onClose]);

    // Trinity event when shown
    useEffect(() => {
        if (!isOpen) return;
        popoverSeen?.()
    }, [])

    if (!isOpen) return null;

    return (
        <>
            <div className="intro-popover__arrow" aria-hidden="true" />
            <div
                ref={popoverRef}
                className="intro-popover"
                role="dialog"
                aria-modal="false"
                aria-label={ariaLabel}
                style={{"--popover-right": popoverRight}}
            >
                <button
                    type="button"
                    className="intro-popover__close"
                    aria-label="Schließen"
                    onClick={onClose}
                >
                    ×
                </button>
                <div className="intro-popover__content">{children}</div>
            </div>
        </>
    );
}
